import React from "react";

function CostReportTable(props) {
  const { data, totalValues } = props;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper tax-table">
        <table className="table last-column">
          <thead>
            <>
              <tr className="">
                <th scope="col">Txn.Date</th>
                <th scope="col">Brokerage</th>
                <th scope="col">GST (₹)</th>
                <th scope="col">Sec.Txn.Tax </th>
                <th scope="col">Stamp Duty</th>
                <th scope="col">IPFT CHRG</th>
                <th scope="col">Sebi Fees</th>
                <th scope="col">Txn Charges</th>
                <th scope="col">Other Charges</th>
                <th scope="col">Total Charges</th>
              </tr>
            </>
          </thead>
          <tbody>
            {data &&
              data.map((item, key) => {
                return (
                  <>
                    <tr key={key} className="">
                      <td>{item?.txnDate || "-"}</td>
                      <td>{item?.brokerage || 0}</td>
                      <td>{item?.gst || 0}</td>
                      <td>{item?.secTxnTax || 0}</td>
                      <td>{item?.stampDuty || 0}</td>
                      <td>{item?.ipftChrg || 0}</td>
                      <td>{item?.sebiFees || 0}</td>
                      <td>{item?.txnCharges || 0}</td>
                      <td>{item?.otherCharges || 0}</td>
                      <td>{item?.totalCharges || 0}</td>
                    </tr>
                  </>
                );
              })}
          </tbody>

          <tbody className="tax-total-values">
            <tr>
              <td>Total</td>
              <td>{totalValues.totalBrokerage}</td>
              <td>{totalValues.totalGst}</td>
              <td>{totalValues.totalSecTxnTax}</td>
              <td>{totalValues.totalStampDuty}</td>
              <td>{totalValues.totalIpftCharge}</td>
              <td>{totalValues.totalSebiFees}</td>
              <td>{totalValues.totalTxnChrg}</td>
              <td>{totalValues.totalOthrChrg}</td>
              <td>{totalValues.totalChrg}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
export default CostReportTable;
